import { USER_ACTIONS } from '../actions/users';

const initialState = {
  users: [],
  applications: [],
  loading: false,
  error: null
};


const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_ACTIONS.SET_USERS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };

    case USER_ACTIONS.DELETE_USER:
      return {
        ...state,
        users: state.users.filter(user => user.userId !== action.payload)
      };

    case USER_ACTIONS.ADD_USER:
      return {
        ...state,
        users: [ ...state.users, action.payload]
    }

    case USER_ACTIONS.UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        
      };
    
    case USER_ACTIONS.UPDATE_USER_ROLE:
      return {
        ...state,
        users: state.users.map(user =>
          user.userId === action.payload.userId ? { ...user, role: action.payload.role } : user
        )
      };

    default:
      return state;
  }
};

export default usersReducer;
